import { html } from "lit-html"

import { parseDate } from "../../utils"

const formatTimeDisplay = (dt) => {
  return dt
    .toLocaleTimeString("en-US", {
      hour12: true,
      hour: "numeric",
      minute: "2-digit",
    })
    .replace(":00", "")
    .replace("AM", "a.m.")
    .replace("PM", "p.m.")
}

export const DateTimeInfo = (
  {
    date,
    start_time,
    end_time,
    shortened_timezone,
    recurring_info,
    canceled,
    agency,
    program,
  },
  expanded = false
) => {
  const startStr = start_time ? `${date} ${start_time}` : date
  const start = parseDate(startStr)
  const startDate = start.toLocaleDateString("en-US", {
    weekday: "long",
    month: "short",
    day: "numeric",
    year: "numeric",
  })
  const startTime = start_time ? formatTimeDisplay(start) : ``
  const endStr = end_time ? `${date} ${end_time}` : date
  const end = parseDate(endStr)
  const endTime = end_time ? formatTimeDisplay(end) : ``

  return html`
    <div class="flex flex-wrap">
      <div class="mr-6">
        ${recurring_info ||
        html`<i
          class="far fa-clock mr-2 w-7 ${canceled
            ? `text-gray-icon`
            : `text-gray-450`}"
        ></i>`}
        <span class="${canceled ? `line-through` : ``}">
          ${startDate}
          ${startTime
            ? `${startTime}${
                endTime ? ` - ${endTime}` : ``
              } ${shortened_timezone}`
            : ``}
        </span>
      </div>
      ${agency
        ? html`
            <div class="mr-6">
              <i class="fas fa-city mr-2 w-7 text-gray-450"></i>
              ${expanded
                ? html`<a href="${agency.url}">${agency.name}</a>`
                : html`<span>${agency.name}</span>`}
            </div>
          `
        : ``}
      ${program
        ? html`
            <div class="mr-6">
              <i class="fas fa-city mr-2 w-7 text-gray-450"></i>
              <span>${program.name}</span>
            </div>
          `
        : ``}
    </div>
  `
}
